import { StaticInterface } from '../../../helpers/static-interface';
import Lottie from 'lottie-web';
import { illustration } from './illustration';

export interface ITpxHubsUtils {
    loadLottie(parentEl: HTMLElement, json: Object): void;
}

export interface IStaticHubsUtils {
    new(...args: any[]): ITpxHubsUtils;
    init(): void;
}

/**
 * Hubs utilities
 * @class
 */
export default class TpxHubsUtils
    implements StaticInterface<IStaticHubsUtils, typeof TpxHubsUtils> {
    constructor(element: HTMLElement) {
        this.loadLottie(element, illustration);
    }

    /**
     * Load lottie animations
     */
    loadLottie(parentEl: HTMLElement, json: Object): void {
        const container = parentEl.querySelector(
            '[data-component="hubs-block-animation"]'
        );
        const animationFallback = parentEl.querySelector(
            '[data-component="hubs-block-animation-fallback"]'
        );

        if (container !== null) {
            const prefersReducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
            if (prefersReducedMotion && animationFallback) {
                animationFallback.classList.remove("hide");
                container.classList.add("hide");
            }
            else {
                Lottie.loadAnimation({
                    animationData: json,
                    container,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                });
            }

        }
    }

    /**
     * Create new instances of TpxHubs for each element with attribute data-component="hubs-block"
     */
    static init(scope?: HTMLElement) {
        [
            ...(scope || document).querySelectorAll('[data-component="hubs-block"]'),
        ].forEach((hub) => {
            new TpxHubsUtils(hub as HTMLElement);
        });
    }
}